import React from 'react';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import { Box, Stack, Typography } from '@mui/material';
import { Button } from '../../../../components/ui';
import { useFeatureTheme } from '../../../../theme/hooks/useFeatureTheme';
import { FORM_STUDIO_COPY } from '../constants/formStudioConfig';

export default function FormCreatedSuccessCallout({
  formName = '',
  onAddFields,
  onDismiss,
}) {
  const { semantic, radiusPx, typographyStyles } = useFeatureTheme();
  const copy = FORM_STUDIO_COPY.createSuccess;
  const title = formName?.trim()
    ? `${formName.trim()} saved`
    : copy.title;

  return (
    <Box
      sx={{
        mb: 2,
        p: { xs: 1.5, sm: 2 },
        borderRadius: radiusPx.md,
        border: `1px solid ${semantic.states.success}`,
        bgcolor: semantic.states.successSoft,
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.5}
        alignItems={{ xs: 'stretch', sm: 'flex-start' }}
        justifyContent="space-between"
      >
        <Stack direction="row" spacing={1.25} alignItems="flex-start" sx={{ minWidth: 0, flex: 1 }}>
          <Box
            sx={{
              mt: 0.25,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 36,
              height: 36,
              borderRadius: radiusPx.md,
              bgcolor: semantic.surfaces.surface,
              color: semantic.states.success,
              flexShrink: 0,
            }}
          >
            <CheckCircleOutline fontSize="small" />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ ...typographyStyles.bodyText, fontWeight: 600, color: semantic.states.success }}>
              {title}
            </Typography>
            <Typography
              sx={{
                ...typographyStyles.caption,
                color: semantic.text.secondary,
                mt: 0.5,
                lineHeight: 1.45,
              }}
            >
              {copy.description}
            </Typography>
          </Box>
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ flexShrink: 0 }}>
          <Button variant="primary" onClick={onAddFields}>
            {copy.addFields}
          </Button>
          <Button variant="outline" onClick={onDismiss}>
            {copy.stayHere}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
